import React from "react";
import { useFormikContext } from "formik";
import { useIntl } from "react-intl";
import { Input, Row, Space } from "@masterteam/mt-design-react";
import moment from "moment";
import groupBy from "lodash/groupBy";

import styles from "./KPIMeasuresField.module.scss";

function KPIMeasuresField({
  isReadOnly = false,
  kpiMeasures = {},
  isChangeKpiTarget,
  disabledMeasures = false,
  frequency = null
}) {
  const intl = useIntl();
  const { errors, setFieldValue, values } = useFormikContext();

  const list = groupBy(values.KPIMeasures, "Year");

  const isRange = values.CalculationMethod?.Value === "4";

  const getExtraLabel = (item) => {
    const month = new Date(item.DueDate).getMonth();

    if (values?.Frequency?.Value === "quarterly" || frequency === "quarterly") {
      return `/ ${intl.formatMessage({
        id: `kpi-info.${Math?.trunc(month / 3) + 1}-quarter`
      })}`;
    } else if (
      values?.Frequency?.Value === "semi-annual" ||
      frequency === "semi-annual"
    ) {
      return `/ ${intl.formatMessage({
        id: `frequency.Semi-Annual`
      })} ${Math?.trunc(month / 6) + 1}`;
    } else return "";
  };

  if (isReadOnly)
    return (
      <Space
        direction="vertical"
        size="medium"
        className={styles.measuresContainer}
      >
        {Object.keys(kpiMeasures).map((key) => (
          <Space direction="vertical" key={key}>
            <Row className={styles.header}>{key}</Row>
            <Row align="center" gap={5}>
              {kpiMeasures[key].map((item) => (
                <Space
                  className={styles.input}
                  direction="vertical"
                  key={`t-${item.DueDate}`}
                >
                  <div className="freq-label">
                    {`${moment(item.DueDate, "MM-DD-YYYY")
                      .locale(intl.locale)
                      .format("MMM")} ${getExtraLabel(item)}`}
                  </div>
                  <Input
                    disabled={true}
                    type="number"
                    min={0}
                    step="any"
                    error={errors.KPIMeasures?.[item.ItemIndex]?.Target}
                    value={item.Target}
                    key={`${item.ItemIndex}${item?.Target ?? 0}`}
                  />
                </Space>
              ))}
            </Row>
          </Space>
        ))}
      </Space>
    );

  return (
    <Space
      direction="vertical"
      size="medium"
      className={styles.measuresContainer}
    >
      {Object.keys(list).map((key) => (
        <Space direction="vertical" key={key}>
          <Row className={styles.header}>{key}</Row>
          <Row align="center" gap={5}>
            {isRange && (
              <span>{intl.formatMessage({ id: "common.from" })}</span>
            )}
            {list[key].map((item, index) => (
              <Space
                className={styles.input}
                direction="vertical"
                key={`t-${item.DueDate}${item?.ID ?? index}`}
              >
                <div className="freq-label">
                  {`${moment(item.DueDate, "MM-DD-YYYY")
                    .locale(intl.locale)
                    .format("MMM")} ${getExtraLabel(item)}`}
                </div>
                <Input
                  disabled={
                    disabledMeasures || !item?.IsEditable
                    // (isChangeKpiTarget
                    //   ? !item?.IsEditable
                    //   : item.Status
                    //   ? item.Status === "Not Started"
                    //     ? false
                    //     : true
                    //   : false)
                  }
                  type="number"
                  min={0}
                  step="any"
                  error={errors.KPIMeasures?.[item.ItemIndex]?.Target}
                  value={item.Target}
                  onKeyDown={(evt) => {
                    if (evt.key === "e" || evt.key === "-" || evt.key === "+") {
                      evt.preventDefault();
                    }
                  }}
                  onChange={(e) => {
                    const value = e.target.value;
                    setFieldValue(
                      `KPIMeasures[${item.ItemIndex}.Target]`,
                      value
                    );
                  }}
                  key={`${item.ItemIndex}${item?.Target ?? 0}`}
                />
              </Space>
            ))}
          </Row>
          {isRange && (
            <Row align="center" gap={5}>
              <span>{intl.formatMessage({ id: "common.to" })}</span>
              {list[key].map((item) => (
                <div className={styles.input} key={`nt-${item.DueDate}`}>
                  <Input
                    disabled={
                      item.Status
                        ? item.Status === "Not Started"
                          ? false
                          : true
                        : false
                    }
                    type="number"
                    min={0}
                    step="any"
                    error={errors.KPIMeasures?.[item.ItemIndex]?.MaxTarget}
                    value={item.MaxTarget}
                    onKeyDown={(evt) => {
                      if (
                        evt.key === "e" ||
                        evt.key === "-" ||
                        evt.key === "+"
                      ) {
                        evt.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      const value = e.target.value;
                      setFieldValue(
                        `KPIMeasures[${item.ItemIndex}.MaxTarget]`,
                        value
                      );
                    }}
                  />
                </div>
              ))}
            </Row>
          )}
        </Space>
      ))}
    </Space>
  );
}

export default KPIMeasuresField;
